import { DetailedError, hc, parseResponse } from "hono/client";
//#region src/client.ts
const PROD_BASE_URL = "https://style.maps.atrius.com";
const createRawClient = (baseUrl = PROD_BASE_URL, fetchConfig) => {
	return hc(baseUrl, { fetch: fetchConfig?.fetch ?? fetch });
};
const createStyleApiClient = (baseUrl = PROD_BASE_URL, fetchConfig) => {
	const client = createRawClient(baseUrl, fetchConfig);
	return {
		getStyleForVertical: async (vertical) => {
			const { data } = await parseResponse(client.v1.vertical[":vertical"].$get({ param: { vertical } }));
			return data;
		},
		getStyleForVenue: async (vertical, venueId) => {
			const { data } = await parseResponse(client.v1.vertical[":vertical"].venue[":venueId"].$get({ param: {
				vertical,
				venueId
			} }));
			return data;
		},
		getStyleV2: async (venueId, category) => {
			const { data } = await parseResponse(client.v2.style.$get({ query: {
				venueId,
				category
			} }));
			return data;
		}
	};
};
//#endregion
export { DetailedError, createRawClient, createStyleApiClient };

//# sourceMappingURL=client.mjs.map